import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import {
  AuthService,
  CandidateSessionService
} from '../services/auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  console.log(
    '🔥 AUTH INTERCEPTOR EXECUTED:',
    req.method,
    req.url
  );

  const auth =
    inject(AuthService);

  const candidateSession =
    inject(CandidateSessionService);

  // =========================================================
  // PUBLIC APIs
  // =========================================================

  const isCandidateSessionApi =
    req.url.includes(
      '/api/Proctoring/candidate-session'
    );

  const isVerifyQrApi =
    req.url.includes(
      '/api/Proctoring/verify-qr'
    );

  const isAuthApi =
    req.url.includes('/api/Auth/');

  if (
    isCandidateSessionApi ||
    isVerifyQrApi ||
    isAuthApi
  ) {

    console.log(
      '🟢 PUBLIC API:',
      req.url
    );

    return next(req);
  }

  // =========================================================
  // CHECK ACTIVE SESSIONS
  // =========================================================

  const candidateToken =
    candidateSession.getAccessToken();

  const adminToken =
    auth.getAccessToken();

  console.log(
    '🎓 Candidate token:',
    candidateToken
      ? 'FOUND'
      : 'NOT FOUND'
  );

  console.log(
    '👨‍💼 Admin token:',
    adminToken
      ? 'FOUND'
      : 'NOT FOUND'
  );

  // =========================================================
  // CANDIDATE SESSION
  // =========================================================

  if (candidateToken && !adminToken) {

    console.log(
      '🎓 Using Candidate JWT:',
      req.url
    );

    return next(
      req.clone({
        setHeaders: {
          Authorization:
            `Bearer ${candidateToken}`
        }
      })
    );
  }

  // =========================================================
  // ADMIN SESSION
  // =========================================================

  if (adminToken && !candidateToken) {

    console.log(
      '👨‍💼 Using Admin JWT:',
      req.url
    );

    return next(
      req.clone({
        setHeaders: {
          Authorization:
            `Bearer ${adminToken}`
        }
      })
    );
  }

  // =========================================================
  // BOTH TOKENS EXIST
  // =========================================================

  if (candidateToken && adminToken) {

    console.warn(
      '⚠️ Both Candidate and Admin sessions exist.'
    );

    /*
     * IMPORTANT:
     * We cannot determine from the URL whether
     * this is an Admin or Candidate API because
     * both are currently using /api/Proctoring/.
     *
     * For now use Admin JWT as default.
     */

    console.log(
      '👨‍💼 Using Admin JWT:',
      req.url
    );

    return next(
      req.clone({
        setHeaders: {
          Authorization:
            `Bearer ${adminToken}`
        }
      })
    );
  }

  // =========================================================
  // NO TOKEN
  // =========================================================

  console.warn(
    '⚠️ No authentication token found:',
    req.url
  );

  return next(req);
};
